export default "__VITE_ASSET__d2750b0b__"